import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class GroupTabForm extends React.Component {
    static propTypes = {
        payment_processor: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            name: '',
        };
    }

    onUpdatePaymentName = () => {
        this.props.payment_processor.setPaymentName(this.state.name);
    };

    render() {
        const { t } = this.props;
        return (
            <div className="m2g-order-confirmation-group-tab-input-group">
                <input
                    className="m2g-order-confirmation-group-tab-name-input m2g-input m2g-form-element--three-quarter-width inspectletIgnore"
                    type="text"
                    data-group-tabs-name
                    placeholder={t('payment_name_placeholder')}
                    autoComplete="off"
                    value={this.state.name}
                    onChange={e =>
                        this.setState(
                            { name: e.target.value },
                            this.onUpdatePaymentName
                        )
                    }
                />
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(GroupTabForm);
